<template>
  <SectionTemplate
    title="为全球企业信赖的AI语音生成引擎"
    subTitle="企业级AI语音引擎"
    theme="light"
    :desc="`魔珐有言的AI语音引擎以卓越的稳定性与顶尖的拟真度，成为数千家企业的共同选择。我们提供覆盖全球的多语言支持、精准的情感化合成、\n完美的口型同步以及独家的声音克隆技术，为您提供专业、可靠的声音解决方案。`"
  >
    <div class="card-list">
      <FeatureCard
        v-for="(feature, index) in featureList"
        :key="index"
        v-bind="feature"
        btnText="免费试用"
      />
    </div>
  </SectionTemplate>
</template>

<script setup lang="ts">
import FeatureCard from '@/design/components/feature-card/index.vue';
import SectionTemplate from '~/design/widgets/landing-section/cn-template.vue';

const featureList = [
  {
    title: `电影级音质
告别机械配音`,
    description:
      '采用领先的TTS语音合成技术，AI深度理解文本语境，生成带有自然呼吸感和流畅语调的语音。音质饱满清晰，彻底摆脱电子音的生硬感，为您的视频赋予专业声优般的听觉享受。',
    image: getFeUrl(
      '/youyan-platform/ai-voice/engine/engine-1.png?x-oss-process=image/format,webp',
    ),
    muted: false,
  },
  {
    title: `AI生成情绪化语音
让每句话都充满感染力`,
    description:
      '我们的AI能精准识别文案情绪，并自动匹配对应的语音语调与数字人表情。无论是带货的热情、宣讲的沉稳，还是故事讲述的温情，都能精准演绎，让您的数字人声情并茂，极大提升内容吸引力。',
    image: getFeUrl(
      '/youyan-platform/ai-voice/engine/engine-2.png?x-oss-process=image/format,webp',
    ),

    reverse: true,
  },
  {
    title: `一键切换多语种视频
快速拓展海外市场`,
    description:
      '内置英语、法语、日语等20+种语言与多种方言可选，无需昂贵的人工配音。输入文案，即可一键翻译并生成地道的当地语言视频。极大降低跨国跨地区沟通成本，助力企业培训、产品营销快速覆盖全球目标受众。',
    image: getFeUrl(
      '/youyan-platform/ai-voice/engine/engine-3.png?x-oss-process=image/format,webp',
    ),
  },
  {
    title: `音画严格同步
打造无懈可击的逼真感`,
    description:
      '核心技术确保生成的每一句语音，都能驱动数字人生成高度匹配的精准口型与微表情。消除音画不同步的尴尬，让数字人表现无比真实可信，成就专业级的视频作品。',
    image: getFeUrl(
      '/youyan-platform/ai-voice/engine/engine-4.png?x-oss-process=image/format,webp',
    ),

    reverse: true,
  },
];
</script>

<style lang="scss" scoped>
.card-list {
  @apply flex-col items-center gap-[240px];
}

@media (max-width: $media-mobile) {
  .card-list {
    gap: 72px;
  }
}
</style>
